import React, { useEffect } from 'react';
import './App.scss';
import BookingWidget from './components/BookingWidget/BookingWidget';
import { BookingConfigContextProvider } from './context/bookingConfigContext/bookingConfigContext';
import { BookingContextProvider } from './context/bookingContext/bookingContext';
import Spinner from './shared/components/Loading/Spinner';
import { LoadingProvider } from './context/loadingContext/loadingContext';
import { NotificationProvider } from './shared/components/Notification/NotificationContext';
import { AgentConfigContextProvider } from './context/agentContext/agentConfigContext';
import { BookingQuoteContextProvider } from './context/quoteContext/quoteContext';
import { BookingDataContextProvider } from './context/bookingDataContext/bookingDataContext';
import { HomeMedicalProvider } from './context/homeMedicalContext/homeMedicalContext';
import { DiscountProvider } from './context/discountContext/discountContext';
import { AppConfigurationContextProvider } from './context/appConfigurationContext/appConfigurationContext';
import { StepperContextProvider } from './context/stepperContext/stepperContext';
import { CacheDataProvider } from './context/cacheContext/cacheContext';
import { PriceSummaryProvider } from './context/priceSummaryContext/priceSummaryContext';
import { SessionProvider } from './context/sessionContext/sessionContext';
import { PreviousBookingContextProvider } from './context/previousBookingContext/previousBookingContext';
import ConfiguredThemeProvider from './themes/ConfiguredThemeProvider';

export const ThemeContext = React.createContext(null);
interface ParentScrolledEvent extends Event {
  data: {
    scrollPosition: number;
    topDistance?: number;
  };
}

function App(): JSX.Element {
  useEffect((): void => {
    localStorage.setItem('language', 'en');
  }, []);

  useEffect(() => {
    const listenerFunction = (event: ParentScrolledEvent): void => {
      const { scrollPosition, topDistance } = event.data;
      const rightPanelStickyContainer =
        document.getElementsByClassName('sticky-container')[0];

      if (
        scrollPosition === undefined ||
        rightPanelStickyContainer === undefined
      ) {
        return;
      }

      if (scrollPosition === 0) {
        rightPanelStickyContainer.removeAttribute('style');
        return;
      }

      const marginTop = scrollPosition - (topDistance ?? 0);
      rightPanelStickyContainer.setAttribute(
        'style',
        `top: ${marginTop}px !important; transition: top .5s .1s`,
      );
    };

    window.addEventListener('message', listenerFunction);

    return () => {
      window.removeEventListener('message', listenerFunction);
    };
  }, []);

  return (
    <LoadingProvider>
      <CacheDataProvider>
        <SessionProvider>
          <PreviousBookingContextProvider>
            <BookingConfigContextProvider>
              <ConfiguredThemeProvider>
                <BookingQuoteContextProvider>
                  <BookingDataContextProvider>
                    <NotificationProvider>
                      <BookingContextProvider>
                        <DiscountProvider>
                          <PriceSummaryProvider>
                            <HomeMedicalProvider>
                              <AgentConfigContextProvider>
                                <AppConfigurationContextProvider>
                                  <StepperContextProvider>
                                    <Spinner />
                                    <BookingWidget />
                                  </StepperContextProvider>
                                </AppConfigurationContextProvider>
                              </AgentConfigContextProvider>
                            </HomeMedicalProvider>
                          </PriceSummaryProvider>
                        </DiscountProvider>
                      </BookingContextProvider>
                    </NotificationProvider>
                  </BookingDataContextProvider>
                </BookingQuoteContextProvider>
              </ConfiguredThemeProvider>
            </BookingConfigContextProvider>
          </PreviousBookingContextProvider>
        </SessionProvider>
      </CacheDataProvider>
    </LoadingProvider>
  );
}

export default App;
